import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FerramentasDeDetalhe, RadioGroup, CheckBox, ILstLiga } from "../../shered/components";
import { VForm, VTextField, VScope, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { IDetalheMensagemPorUsuario, IDetalheMensagemPorUsuarioCreate, IDetalheUsuario, UsuarioService } from "../../shered/services/api/usuario/UsuarioService";
import CookieService from "../../shered/services/autenticacao/CookieService";
import {
    Box, FormControl, FormControlLabel, Paper, Switch, Typography, useTheme,
    Tab,
    Autocomplete,
    Checkbox as MuiCheckBox,
    Table, TableBody, TableCell,
    TableContainer, TableFooter, TableHead,
    TableRow, Tabs,
    tableCellClasses,
    tabsClasses,
    Select,
    MenuItem,
    InputLabel,
    Tooltip,
    IconButton,
    Icon,
    TextField,
    CircularProgress,
    Button,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import clsx from 'clsx';
import { DataGrid, GridCellParams, GridColDef, GridSaveAltIcon } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { ILstDrop, lstPosicaoAmericana, lstPosicaoAmericano, lstReferenciasPosicao, TDropOptions, TipoSalario, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { LigaService } from "../../shered/services/api/liga/LigaService";
import { FranquiaService, IDadosCadastroPorFranquia, IDadosFranquiaJogador, IDadosFranquiaMultasAnual, IDadosResumoPicksAno, IDetalheFranquia } from "../../shered/services/api/franquia/FranquiaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { styled } from '@mui/material/styles';
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { IListagemJogador, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { EstatisticasService, IDadosRecordes } from "../../shered/services/api/estatisticas/EstatisticasService";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ?
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {
                    // value === index && (
                    <Box sx={{ p: 3 }}>
                        <Grid container>{children}</Grid>
                    </Box>
                    //)
                }
            </div>
            : ""}
        </>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: UtilidadeService.isMobile() ? 10 : 14,
        padding: UtilidadeService.isMobile() ? "5px" : 8,

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: UtilidadeService.isMobile() ? 10 : 14,
        padding: "4px",

    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
        padding: UtilidadeService.isMobile() ? "8px 5px" : "12px 8px",
    },
}));

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustom(props, ref) {
        const { onChange, ...other } = props;

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}

                thousandSeparator={'.'}
                decimalSeparator={','}
                valueIsNumericString
                prefix="R$"
            />
        );
    },
);

export const ListagemDeRecordes: React.FC = () => {
    const user = CookieService.get("access_user");
    const { themeName } = useAppThemeContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [value, setValue] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const theme = useTheme();
    const [removeLoading, setRemoveLoading] = useState(false);
    const navigate = useNavigate();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const { logout } = useAuthContext();
    const [redirecionar, setRedirecionar] = useState("0");
    const [adm, setAdm] = useState(user.administrador);
    const [cod_Usuario, setCod_Usuario] = useState(0);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [usuarioComissario, setUsuarioComissario] = useState(false);
    const [franquiaFiltroLiga, setFranquiaFiltroLiga] = useState(0);
    const [franquiaFiltroSite, setFranquiaFiltroSite] = useState(0);
    const [rowsJogadores, setRowsJogadores] = useState<IListagemJogador[]>([]);
    const [franquia, setFranquia] = useState<IDetalheFranquia>();
    const [lstFraqnuias, setLstFranquias] = useState<ILstDrop[]>([]);
    const [totalCountRecordesLiga, setTotalCountRecordesLiga] = useState(0);
    const [totalCountRecordesSite, setTotalCountRecordesSite] = useState(0);
    const [estatisticasLigaRows, setEstatisticasLigaRows] = useState<IDadosRecordes[]>([]);
    const [estatisticasSiteRows, setEstatisticasSiteRows] = useState<IDadosRecordes[]>([]);
    const [showImagemJogador, setShowImagemJogador] = useState<any>("../../semimagem.png");
    const [nomeLiga, setNomeLiga] = useState("");
    const [rows, setRows] = useState<IListagemJogador[]>([]);
    const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([])
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [listaStats, setListaStats] = useState<ILstDrop[]>([]);
    const [temporadaFiltroLiga, setTemporadaFiltroLiga] = useState(0);
    const [temporadaFiltroSite, setTemporadaFiltroSite] = useState(0);
    const [codigoStatsFiltroSite, setCodigoStatsFiltroSite] = useState(0);
    const [codigoStatsFiltroLiga, setCodigoStatsFiltroLiga] = useState(0);
    const [statsFiltroLiga, setStatsFiltroLiga] = useState(0);
    const [statsFiltroSite, setStatsFiltroSite] = useState(0);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteJogador]);


    useEffect(() => {
        const user = CookieService.get("access_user");
        setAdm(user.administrador);
        setCod_Usuario(user.codUsuario);
        setIsLoading(false);
        setRemoveLoading(true);

        const fetchData = async () => {
            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    setNomeLiga(liga.nome);
                    setTemporadaFiltroSite(liga.codigo_Temporada);
                    setTemporadaFiltroLiga(liga.codigo_Temporada);
                    handlePesquisar(liga.codigo_Temporada, 0, 0)

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        else {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });

                            return;
                        }
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia. Favor tentar mais tarde e se persistir o problema, entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });

                    return;
                });
            await FranquiaService.getByIdLiga(Number(codigoLiga))
                .then((result) => {
                    const franquias = result.dado;
                    let lstFranquiasAux = franquias.map((f, i) => ({ codigo: f.codigo, label: f.nome }));
                    setLstFranquias(lstFranquiasAux);

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });

            await UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                .then((result) => {
                    const tmps = result.data.dado;
                    let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                    setLstTemporadas(lstTemporadasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;

                });

            await UtilidadeService.getStatsLigaPorCodigoLiga(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const lstStats = result.data.dado;
                    let lst = lstStats.map((m) => ({ codigo: m.codigo, label: m.nome }));
                    setListaStats(lst);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });

            //  CarregarDadosJogadores(true);

        }
        fetchData();
    }, []);


    // const CarregarDadosJogadores = async (atualizarAutoComplete: boolean) => {
    //     await JogadorService.getTodosJogadores(Number(codigoLiga), selectedIdComplete, 0, 0, "", 1)
    //         .then(result => {
    //             setRowsJogadores(result.data.dado);
    //             const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
    //                 .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
    //             if (atualizarAutoComplete === true) {
    //                 setOpcoesAutoCompleteJogador(lstDrop);
    //             }
    //         }).catch((errors) => {
    //             setIsLoading(false);
    //             setShowModalMensagem(true);
    //             if (errors.response.data.statusHTTP === 401) {
    //                 setDadosModalMensagem({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "error",
    //                     mensagem: "Sessão Expirada! 1",
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //                 logout();
    //                 setRedirecionar("0");
    //                 return;
    //             }
    //             if (errors.response.data.mensagem !== undefined) {
    //                 setDadosModalMensagem({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "error",
    //                     mensagem: errors.response.data.mensagem,
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //             }
    //             else {
    //                 setDadosModalMensagem({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "error",
    //                     mensagem: "Não foi possível carregar os dados dos jodadores! Favor entrar em contato com a TI",
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //             }
    //         });
    // }

    // const handleCarregarDadosJogadores = (codigoFranquia: number) => {
    //     //LimparListas();

    //     setIsLoading(true);
    //     setRemoveLoading(false);

    //     if (codigoFranquia === 0) {
    //         setIsLoading(false);
    //         setRemoveLoading(true);
    //         setShowModalMensagem(true);
    //         setDadosModalMensagem({
    //             acao: true,
    //             label: "",
    //             tipo: "info",
    //             mensagem: "Favor informar uma franquia!",
    //             display: "none",
    //             titulo: "Atenção"
    //         });
    //         return;
    //     }

    //     // FranquiaService.getByIdFranquia(codigoFranquia)
    //     //     .then((result) => {
    //     //         let resultado = result.dado;
    //     //         setIsLoading(false);
    //     //         setRemoveLoading(true);
    //     //         setFranquia(franquia);
    //     //         setEstatisticasLigaRows(resultado..franquia_Jogador.length > 0 ? franquia.franquia_Jogador : []);
    //     //         setTotalCountJogadores(franquia.franquia_Jogador.length > 0 ? franquia.franquia_Jogador.length : 0);


    //     //     }).catch((errors) => {
    //     //         setIsLoading(false);
    //     //         setShowModalMensagem(true);
    //     //         if (errors.response.data.statusHTTP === 401) {
    //     //             setDadosModalMensagem({
    //     //                 acao: true,
    //     //                 label: "",
    //     //                 tipo: "error",
    //     //                 mensagem: "Sessão Expirada!",
    //     //                 display: "none",
    //     //                 titulo: "Atenção"
    //     //             });
    //     //             logout();
    //     //             setRedirecionar("0");
    //     //             return;
    //     //         }
    //     //         if (errors.response.data.mensagem !== undefined) {
    //     //             setDadosModalMensagem({
    //     //                 acao: true,
    //     //                 label: "",
    //     //                 tipo: "error",
    //     //                 mensagem: errors.response.data.mensagem,
    //     //                 display: "none",
    //     //                 titulo: "Atenção"
    //     //             });
    //     //         }
    //     //         else {
    //     //             setDadosModalMensagem({
    //     //                 acao: true,
    //     //                 label: "",
    //     //                 tipo: "error",
    //     //                 mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
    //     //                 display: "none",
    //     //                 titulo: "Atenção"
    //     //             });
    //     //         }
    //     //     });
    // }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        // handleCarregarDadosJogadores(franquiaFiltro);
        //navigate(0);

    }

    const handleSave = async (dados: IDetalheMensagemPorUsuarioCreate[]) => {
        // UsuarioService.createConfiguracaoMensagem(listaPermissoes)
        //     .then((result) => {
        //         setIsLoading(false);
        //         setRemoveLoading(true);
        //         setShowModalMensagem(true);
        //         setDadosModal({
        //             acao: true,
        //             label: "",
        //             tipo: "success",
        //             mensagem: "Registro cadastrado com sucesso!",
        //             display: "none",
        //             titulo: "Atenção"
        //         });
        //         // if (isSaveAndClose()) {
        //         //     setRedirecionar("/adm/usuarios");
        //         // } else {
        //         //     setRedirecionar(`/usuario/usuarios/detalhe/${result}`);
        //         // }
        //     })
        //     .catch((errors) => {
        //         setRemoveLoading(true);
        //         setShowModalMensagem(true);
        //         if (errors.response.status === 401) {
        //             setDadosModal({
        //                 acao: true,
        //                 label: "",
        //                 tipo: "info",
        //                 mensagem: "Sessão expirada!",
        //                 display: "none",
        //                 titulo: "Atenção"
        //             });
        //             logout();
        //             setRedirecionar("0");
        //             return;
        //         }
        //         setDadosModal({
        //             acao: true,
        //             label: "",
        //             tipo: "error",
        //             mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível criar a liga! Favor entrar em contato com a TI.",
        //             display: "none",
        //             titulo: "Atenção"
        //         });
        //     });

    }

    const handleLimparCampos = () => {
        setSelectedIdComplete(0);

    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };


    const handlePesquisar = async (codigoTemporada: number, codigoFranquia: number, codigoStats: number) => {
        setEstatisticasLigaRows([]);
        setEstatisticasSiteRows([]);
        EstatisticasService.getRecordes(Number(codigoLiga), codigoTemporada, codigoFranquia, codigoStats)
            .then((result) => {
                let resultado = result.dado;
                setIsLoading(false);
                setRemoveLoading(true);
                setFranquia(franquia);
                setEstatisticasLigaRows(resultado.recordes_Liga.length > 0 ? resultado.recordes_Liga : []);
                setTotalCountRecordesLiga(resultado.recordes_Liga.length > 0 ? resultado.recordes_Liga.length : 0);
                setEstatisticasSiteRows(resultado.recordes_Site.length > 0 ? resultado.recordes_Site : []);
                setTotalCountRecordesSite(resultado.recordes_Site.length > 0 ? resultado.recordes_Site.length : 0);


            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão Expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response.data.mensagem !== undefined) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
    }

    const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {

        let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;

        let qtd = posicoes.split("|").length;
        let arrImagens = posicoes.split("|");

        let imgs = qtd === 1 ? <img src={`../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
            : qtd === 2 ?
                <>  <img src={`../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
                    <img src={`../${arrImagens[1].trim()}`} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", marginLeft: 4, fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
                </>
                : <> <img src={`../${arrImagens[0]}`} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
                    <img src={`../${arrImagens[1].trim()}`} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", marginLeft: 4, fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
                    <img src={`../${arrImagens[2].trim()}`} alt={"img3"} width={UtilidadeService.isMobile() ? 15 : 20} height={UtilidadeService.isMobile() ? 15 : 20} style={{ borderRadius: "50%", marginLeft: 4, fontSize: UtilidadeService.isMobile() ? "10" : "18" }} />
                </>

        return imgs
    }

    const columnsGeral: GridColDef[] = [
        {
            field: 'codigo',
            headerName: '',
            flex: 1,
            minWidth: 55,
            maxWidth: 55,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            sortable: false


        },
        {
            field: 'foto_Usuario',
            headerName: 'FOTO',
            editable: false,
            flex: 1,
            minWidth: 75,
            maxWidth: 75,
            headerClassName: 'super-app-theme--header',
            //renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 35 : 50} height={UtilidadeService.isMobile() ? 35 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }} />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            sortable: false
        },
        {
            field: 'nome_Usuario',
            headerName: 'NOME',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 130 : 150,
            editable: false,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },

        },
        {
            field: 'logo_Liga',
            headerName: '',
            editable: false,
            flex: 1,
            minWidth: 75,
            maxWidth: 75,
            headerClassName: 'super-app-theme--header',
            //renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 35 : 50} height={UtilidadeService.isMobile() ? 35 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagemescudo.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }} />
                : <img src={"../../../../semimagemescudo.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            sortable: false
        },
        {
            field: 'nome_Liga',
            headerName: 'LIGA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 130 : 150,
            editable: false,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },

        },
        {
            field: 'logo_Franquia',
            headerName: '',
            editable: false,
            flex: 1,
            minWidth: 75,
            maxWidth: 75,
            headerClassName: 'super-app-theme--header',
            //renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 35 : 50} height={UtilidadeService.isMobile() ? 35 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagemescudo.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }} />
                : <img src={"../../../../semimagemescudo.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            sortable: false
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 130 : 150,
            editable: false,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },

        },
        {
            field: 'fgm',
            headerName: 'FGM',
            editable: false,
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'threepm',
            headerName: '3PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"


        },
        {
            field: 'pts',
            headerName: 'PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"


        },
        {
            field: 'reb',
            headerName: 'REB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'oreb',
            headerName: 'OREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'dreb',
            headerName: 'DREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'ast',
            headerName: 'AST',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'stl',
            headerName: 'STL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'blk',
            headerName: 'BLK',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'tor',
            headerName: 'TO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'pf',
            headerName: 'PF',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'mplu',
            headerName: 'MPLU',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 60 : 80,
            maxWidth: UtilidadeService.isMobile() ? 60 : 80,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(params.value.toString()) < 0,
                    positive: parseFloat(params.value.toString()) >= 0,
                });
            },
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'fgmp',
            headerName: 'FGM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 60 : 80,
            maxWidth: UtilidadeService.isMobile() ? 60 : 80,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'ftmp',
            headerName: 'FTM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 60 : 80,
            maxWidth: UtilidadeService.isMobile() ? 60 : 80,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'ftm',
            headerName: 'FTM',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 60 : 80,
            maxWidth: UtilidadeService.isMobile() ? 60 : 80,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'threepmp',
            headerName: '3P%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 60 : 80,
            maxWidth: UtilidadeService.isMobile() ? 60 : 80,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null && params.value > 0 ? params.value : "-"
        },
        {
            field: 'fte',
            headerName: 'FTE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 60 : 80,
            maxWidth: UtilidadeService.isMobile() ? 60 : 80,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined && params.value > 0 ? params.value : "-"
        },
        {
            field: 'fge',
            headerName: 'FGE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 60 : 80,
            maxWidth: UtilidadeService.isMobile() ? 60 : 80,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined && params.value > 0 ? params.value : "-"
        },
        {
            field: 'fga',
            headerName: 'FGA',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 70 : 80,
            maxWidth: UtilidadeService.isMobile() ? 70 : 80,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined && params.value > 0 ? params.value : "-"
        },
        {
            field: 'fta',
            headerName: 'FTA',
            editable: false,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            minWidth: UtilidadeService.isMobile() ? 70 : 80,
            maxWidth: UtilidadeService.isMobile() ? 70 : 80,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined && params.value > 0 ? params.value : "-"
        },
        {
            field: 'threepe',
            headerName: '3PE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 70 : 80,
            maxWidth: UtilidadeService.isMobile() ? 70 : 80,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined && params.value > 0 ? params.value : "-"
        },
        {
            field: 'stocks',
            headerName: 'STOCKS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 70 : 100,
            maxWidth: UtilidadeService.isMobile() ? 70 : 100,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined && params.value > 0 ? params.value : "-"
        },
    ];

    return (
        <LayoutBaseDePagina titulo={`Recordes: ${nomeLiga}`}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoNovo={false}
                    mostrarBotaoSalvar={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={UtilidadeService.isMobile() ? 0 : 2} spacing={2}>
                        <Grid container direction="column" padding={UtilidadeService.isMobile() ? 0 : 2} spacing={2}>
                            <Grid alignItems="center" justifyContent="center" width="100%">
                                <Paper>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <Tabs value={value} onChange={handleChangeTabs} variant="scrollable"
                                            scrollButtons
                                            sx={{
                                                [`& .${tabsClasses.scrollButtons}`]: {
                                                    '&.Mui-disabled': { opacity: 0.3 },
                                                },
                                            }}
                                        >
                                            <Tab label="Recordes Liga"  {...a11yProps(0)} />
                                            <Tab label="Recordes Site"{...a11yProps(1)} />

                                        </Tabs>
                                    </Box>
                                    <TabPanel value={value} index={0}>
                                        {!removeLoading && <Loading />}
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }}
                                            direction="row"
                                            display={"grid"}
                                            padding={UtilidadeService.isMobile() ? 0 : 1} spacing={2}>
                                            <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                <Typography variant="h6">Recordes Liga </Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} margin={1} padding={UtilidadeService.isMobile() ? 0 : 1}  >
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} paddingBottom={2}>
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                                            <Select
                                                                variant="outlined"
                                                                native={false}
                                                                value={temporadaFiltroLiga}
                                                                label="Temporadas"
                                                                onChange={(e) => setTemporadaFiltroLiga(Number(e.target.value))}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                }

                                                            </Select>
                                                        </FormControl >
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <FormControl fullWidth disabled={isLoading}>
                                                        <InputLabel id="demo-simple-select-label">Franquia</InputLabel>
                                                        <Select
                                                            variant="outlined"
                                                            native={false}
                                                            value={franquiaFiltroLiga}
                                                            label="Franquia"
                                                            onChange={(e) => setFranquiaFiltroLiga(Number(e.target.value))}
                                                        >
                                                            <MenuItem value={0}>Todas</MenuItem>
                                                            {
                                                                lstFraqnuias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    </FormControl >
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }} display="none" justifyContent="center">
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Stats</InputLabel>
                                                            <Select
                                                                variant="outlined"
                                                                native={false}
                                                                value={codigoStatsFiltroLiga}
                                                                label="Stats"
                                                                onChange={(e) => setCodigoStatsFiltroLiga(Number(e.target.value))}
                                                            >
                                                                <MenuItem value={0}>Todos</MenuItem>
                                                                {
                                                                    listaStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                }
                                                            </Select>
                                                        </FormControl >
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 2, md: 2 }} display={"flex"} justifyContent={"end"} alignSelf={"center"}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={() => handlePesquisar(temporadaFiltroLiga, franquiaFiltroLiga, codigoStatsFiltroSite)}
                                                        startIcon={<Icon>change_circle</Icon>}
                                                    >
                                                        Pesquisar
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={12} direction="column" padding={UtilidadeService.isMobile() ? 0 : 1}  >
                                                {estatisticasLigaRows.length > 0 ? (
                                                    <Grid size={{ xs: 12, sm: 12 }} padding={UtilidadeService.isMobile() ? 0 : 1} >
                                                        <Box
                                                            sx={{
                                                                height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                '& .super-app-theme--header': {
                                                                    backgroundColor: theme.palette.common.black,
                                                                    color: theme.palette.common.white,
                                                                },
                                                                '& .super-app.negative': {
                                                                    color: 'red',
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .super-app.positive': {
                                                                    //color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                                    fontWeight: '600',
                                                                },
                                                                '& .super-app-theme--cell': {
                                                                    color: '#00e676',
                                                                    fontWeight: 'bold'
                                                                },
                                                                "& .MuiDataGrid-cell": {
                                                                    fontWeight: 'bold'
                                                                },
                                                                '& .MuiDataGrid-main': {
                                                                    height: UtilidadeService.isMobile() ? "380px" : "maxValor",
                                                                    overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                                                },
                                                                '& .MuiDataGrid-columnHeaders ': {
                                                                    //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                                    zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                                                },

                                                            }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(r) => r.codigo}
                                                                rows={estatisticasLigaRows}
                                                                columns={columnsGeral}
                                                                pagination
                                                                initialState={{
                                                                    pagination: {
                                                                        paginationModel: {
                                                                            pageSize: 25,
                                                                        },
                                                                    },
                                                                }}
                                                                columnVisibilityModel={{
                                                                    codigo: false,
                                                                    nome_Liga: false,
                                                                    logo_Liga: false,
                                                                    ast: estatisticasLigaRows.filter(f => f.ast === null).length === 0,
                                                                    blk: estatisticasLigaRows.filter(f => (f.blk === null)).length === 0,
                                                                    dreb: estatisticasLigaRows.filter(f => (f.dreb === null)).length === 0,
                                                                    fga: estatisticasLigaRows.filter(f => (f.fga === null)).length === 0,
                                                                    fgm: estatisticasLigaRows.filter(f => f.fgm === null).length === 0,
                                                                    fgmp: estatisticasLigaRows.filter(f => (f.fgmp === null)).length === 0,
                                                                    fta: estatisticasLigaRows.filter(f => (f.fta === null)).length === 0,
                                                                    ftm: estatisticasLigaRows.filter(f => (f.ftm === null)).length === 0,
                                                                    ftmp: estatisticasLigaRows.filter(f => (f.ftmp === null)).length === 0,
                                                                    mplu: estatisticasLigaRows.filter(f => (f.mplu === null)).length === 0,
                                                                    oreb: estatisticasLigaRows.filter(f => (f.oreb === null)).length === 0,
                                                                    pf: estatisticasLigaRows.filter(f => (f.pf === null)).length === 0,
                                                                    pts: estatisticasLigaRows.filter(f => (f.pts === null)).length === 0,
                                                                    reb: estatisticasLigaRows.filter(f => (f.reb === null)).length === 0,
                                                                    stl: estatisticasLigaRows.filter(f => (f.stl === null)).length === 0,
                                                                    threepa: estatisticasLigaRows.filter(f => (f.threepa === null)).length === 0,
                                                                    threepm: estatisticasLigaRows.filter(f => (f.threepm === null)).length === 0,
                                                                    threepmp: estatisticasLigaRows.filter(f => (f.threepmp === null)).length === 0,
                                                                    to: estatisticasLigaRows.filter(f => (f.to === null)).length === 0,
                                                                    fge: estatisticasLigaRows.filter(f => (f.fge === null || f.fge === undefined)).length === 0,
                                                                    fte: estatisticasLigaRows.filter(f => (f.fte === null || f.fte === undefined)).length === 0,
                                                                    threepe: estatisticasLigaRows.filter(f => (f.threepe === null || f.threepe === undefined)).length === 0,
                                                                    stocks: estatisticasLigaRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                                                                }}
                                                                pageSizeOptions={[25]}
                                                                disableRowSelectionOnClick
                                                                disableColumnMenu
                                                                rowHeight={40}
                                                                columnHeaderHeight={32}
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 11 : 13,
                                                                }}

                                                            />
                                                        </Box>
                                                    </Grid>
                                                ) :
                                                    (
                                                        <Grid size={{ xs: 12, sm: 12 }} >
                                                            <Typography variant="h6">Não possui dados para a temporada selecionada!</Typography>
                                                        </Grid>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={value} index={1}>
                                        {!removeLoading && <Loading />}
                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }} direction="row" display={"grid"} padding={UtilidadeService.isMobile() ? 0 : 1} spacing={2}>
                                            <Grid size={{ xs: 12, sm: 12 }} padding={UtilidadeService.isMobile() ? 0 : 1}  >
                                                <Typography variant="h6">Recordes Site </Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} margin={1} padding={UtilidadeService.isMobile() ? 0 : 1}  >
                                                <Grid size={{ xs: 12, sm: 3, md: 3 }} paddingBottom={2}>
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                                            <Select
                                                                variant="outlined"
                                                                native={false}
                                                                value={temporadaFiltroSite}
                                                                label="Temporadas"
                                                                onChange={(e) => setTemporadaFiltroSite(Number(e.target.value))}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                }

                                                            </Select>
                                                        </FormControl >
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <FormControl fullWidth disabled={isLoading}>
                                                        <InputLabel id="demo-simple-select-label">Franquia</InputLabel>
                                                        <Select
                                                            variant="outlined"
                                                            native={false}
                                                            value={franquiaFiltroSite}
                                                            label="Franquia"
                                                            onChange={(e) => setFranquiaFiltroSite(Number(e.target.value))}
                                                        >
                                                            <MenuItem value={0}>Todas</MenuItem>
                                                            {
                                                                lstFraqnuias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    </FormControl >
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }} display="none" justifyContent="center">
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="demo-simple-select-label">Stats</InputLabel>
                                                            <Select
                                                                variant="outlined"
                                                                native={false}
                                                                value={codigoStatsFiltroSite}
                                                                label="Stats"
                                                                onChange={(e) => setCodigoStatsFiltroSite(Number(e.target.value))}
                                                            >
                                                                <MenuItem value={0}>Todos</MenuItem>
                                                                {
                                                                    listaStats.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                }
                                                            </Select>
                                                        </FormControl >
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 2, md: 2 }} display={"flex"} justifyContent={"end"} alignSelf={"center"}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={() => handlePesquisar(temporadaFiltroSite, franquiaFiltroSite, codigoStatsFiltroSite)}
                                                        startIcon={<Icon>change_circle</Icon>}
                                                    >
                                                        Pesquisar
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} style={{ width: "100%" }}>
                                                {estatisticasSiteRows.length > 0 ? (
                                                    <Box
                                                        sx={{
                                                            height: UtilidadeService.isMobile() ? "690px" : "auto",
                                                            backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                            fontWeight: 'bold',
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white,
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                //color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                                fontWeight: '600',
                                                            },
                                                            '& .super-app-theme--cell': {
                                                                color: '#00e676',
                                                                fontWeight: 'bold'
                                                            },
                                                            "& .MuiDataGrid-cell": {
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .MuiDataGrid-main': {
                                                                height: UtilidadeService.isMobile() ? "380px" : "maxValor",
                                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                                            },
                                                            '& .MuiDataGrid-columnHeaders ': {
                                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                                            }
                                                        }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(r) => r.codigo}
                                                            rows={estatisticasSiteRows}
                                                            columns={columnsGeral}
                                                            //hideFooterPagination={true}
                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 25,
                                                                    },
                                                                },
                                                            }}
                                                            columnVisibilityModel={{
                                                                codigo: false,
                                                                ast: estatisticasSiteRows.filter(f => f.ast === null).length === 0,
                                                                blk: estatisticasSiteRows.filter(f => (f.blk === null)).length === 0,
                                                                dreb: estatisticasSiteRows.filter(f => (f.dreb === null)).length === 0,
                                                                fga: estatisticasSiteRows.filter(f => (f.fga === null)).length === 0,
                                                                fgm: estatisticasSiteRows.filter(f => f.fgm === null).length === 0,
                                                                fgmp: estatisticasSiteRows.filter(f => (f.fgmp === null)).length === 0,
                                                                fta: estatisticasSiteRows.filter(f => (f.fta === null)).length === 0,
                                                                ftm: estatisticasSiteRows.filter(f => (f.ftm === null)).length === 0,
                                                                ftmp: estatisticasSiteRows.filter(f => (f.ftmp === null)).length === 0,
                                                                mplu: estatisticasSiteRows.filter(f => (f.mplu === null)).length === 0,
                                                                oreb: estatisticasSiteRows.filter(f => (f.oreb === null)).length === 0,
                                                                pf: estatisticasSiteRows.filter(f => (f.pf === null)).length === 0,
                                                                pts: estatisticasSiteRows.filter(f => (f.pts === null)).length === 0,
                                                                reb: estatisticasSiteRows.filter(f => (f.reb === null)).length === 0,
                                                                stl: estatisticasSiteRows.filter(f => (f.stl === null)).length === 0,
                                                                threepa: estatisticasSiteRows.filter(f => (f.threepa === null)).length === 0,
                                                                threepm: estatisticasSiteRows.filter(f => (f.threepm === null)).length === 0,
                                                                threepmp: estatisticasSiteRows.filter(f => (f.threepmp === null)).length === 0,
                                                                to: estatisticasSiteRows.filter(f => (f.to === null)).length === 0,
                                                                fge: estatisticasSiteRows.filter(f => (f.fge === null || f.fge === undefined)).length === 0,
                                                                fte: estatisticasSiteRows.filter(f => (f.fte === null || f.fte === undefined)).length === 0,
                                                                threepe: estatisticasSiteRows.filter(f => (f.threepe === null || f.threepe === undefined)).length === 0,
                                                                stocks: estatisticasSiteRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                                                            }}
                                                            pageSizeOptions={[25]}
                                                            disableRowSelectionOnClick
                                                            disableColumnMenu
                                                            rowHeight={40}
                                                            columnHeaderHeight={32}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 11 : 13,
                                                            }}

                                                        />
                                                    </Box>
                                                ) :
                                                    (
                                                        <Grid size={{ xs: 12, sm: 12 }} >
                                                            <Typography variant="h6">Não possui dados para a temporada selecionada!</Typography>
                                                        </Grid>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
};